import type { FilterLeaf } from './types';
export { OPERATOR_LABELS, getOperatorsForFieldType, FilterValueInput } from '../components/FilterRow';
export type { FilterValueInputProps } from '../components/FilterRow';

export function isFilterApplicable(filter: FilterLeaf): boolean {
  if (filter.operator === 'is_empty' || filter.operator === 'is_not_empty') return true;
  const v = filter.value;
  if (v === undefined || v === null) return false;
  if (typeof v === 'string' && v.trim() === '') return false;
  if (Array.isArray(v) && v.length === 0) return false;
  return true;
}
